import { takeEvery, takeLatest } from 'redux-saga/effects';
import { STOPS_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_STOPS_LIST,
  CREATE_STOPS,
  DELETE_STOPS,
  EDIT_STOPS_BY_ID,
  LOAD_STOPS_BY_ID,
} from '../actions';

import loadStopsList from './loadStopsList';
import createStops from './createStops';
import loadStopsById from './loadStopsById';
import editStopsById from './editStopsById';
import deleteStops from './deleteStops';

export default function* watchDashboard() {
  yield takeLatest(STOPS_MODULE + LOAD_STOPS_LIST, loadStopsList);
  yield takeLatest(STOPS_MODULE + CREATE_STOPS, createStops);
  yield takeEvery(STOPS_MODULE + LOAD_STOPS_BY_ID, loadStopsById);
  yield takeEvery(STOPS_MODULE + EDIT_STOPS_BY_ID, editStopsById);
  yield takeEvery(STOPS_MODULE + DELETE_STOPS, deleteStops);
}
